import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import React from 'react'

const Confirmation = ({ closeConfirmation, isConfirmationOpen, confirmationTitle, confirmationMessage, handleConfirmation }) => {
   const [open, setOpen] = React.useState(isConfirmationOpen)

   const handleClose = () => {
      if (closeConfirmation) {
         closeConfirmation()
      } else {
         setOpen(false)
      }
   }

   const confirmed = () => {
      if (handleConfirmation) {
         handleConfirmation()
         handleClose()
      } else {
         handleClose()
      }
   }

   React.useEffect(() => {
      setOpen(isConfirmationOpen)
   }, [isConfirmationOpen])

   return (
      <React.Fragment>
         <div>
            <Dialog
               open={open}
               onClose={handleClose}
               aria-labelledby="confirmation-dialog-title"
               aria-describedby="confirmation-dialog-description"
               fullWidth
               maxWidth="sm"
               PaperProps={{
                  style: {
                     borderRadius: '16px',
                     boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
                     border: 'none',
                     overflow: 'hidden',
                     margin: '20px'
                  }
               }}
               style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
               }}
            >
               <DialogTitle
                  id="confirmation-dialog-title"
                  style={{
                     textAlign: "center",
                     padding: "32px 32px 16px 32px",
                     backgroundColor: "#f8f9fa",
                     borderBottom: "1px solid #e9ecef"
                  }}
               >
                  <span style={{
                     font: "24px/28px Futura Md BT",
                     textAlign: "center",
                     color: "#2c3e50",
                     fontWeight: "600",
                     letterSpacing: "-0.5px"
                  }}>
                     {confirmationTitle}
                  </span>
               </DialogTitle>
               <DialogContent style={{
                  padding: "32px",
                  backgroundColor: "#ffffff"
               }}>
                  <DialogContentText
                     id="confirmation-dialog-description"
                     style={{
                        textAlign: "center",
                        margin: 0,
                        color: "#6c757d",
                        lineHeight: "1.6"
                     }}
                  >
                     <span style={{
                        font: "18px/24px Futura Lt BT",
                        color: "#495057",
                        display: "block",
                        marginBottom: "8px"
                     }}>
                        {confirmationMessage}
                     </span>
                  </DialogContentText>
               </DialogContent>
               <DialogActions style={{
                  padding: "24px 32px 32px 32px",
                  backgroundColor: "#f8f9fa",
                  borderTop: "1px solid #e9ecef",
                  justifyContent: "center",
                  gap: "16px"
               }}>
                  <button
                     onClick={handleClose}
                     style={{
                        width: "140px",
                        height: "48px",
                        backgroundColor: "var(--mainGrey)",
                        color: "#ffffff",
                        font: "18px/20px Futura Md BT",
                        fontWeight: "600",
                        borderRadius: "8px",
                        textTransform: "none",
                        border: "none",
                        outline: "none",

                     }}
                  >
                     Cancel
                  </button>
                  <button
                     onClick={confirmed}
                     style={{
                        width: "140px",
                        height: "48px",
                        backgroundColor: "var(--mainRed)",
                        color: "#ffffff",
                        font: "18px/20px Futura Md BT",
                        fontWeight: "600",
                        borderRadius: "8px",
                        textTransform: "none",
                        border: "none",
                        outline: "none",
                     }}
                     autoFocus
                  >
                     Yes
                  </button>
               </DialogActions>
            </Dialog>

         </div>

      </React.Fragment>
   )
}

export default Confirmation
